import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import CharityVettingAcceptsAllFoodAndNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodAndNonFoodEntry';
import CharityVettingAcceptsAllFoodsEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodsEntry';
import CharityVettingAcceptsAllNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllNonFoodEntry';
import CharityVettingContactDetailsEntry from '../../../common-flow/entries/CharityVettingContactDetailsEntry';
import CharityVettingDonationPreferencesEntry from '../../../common-flow/entries/CharityVettingDonationPreferencesEntry';
import CharityVettingGetStartedEntry from '../../../common-flow/entries/CharityVettingGetStartedEntry';
import CharityVettingLegalRepresentativeEntry from '../../../common-flow/entries/CharityVettingLegalRepresentativeEntry';
import CharityVettingManualContactDetailsEntry from '../../../common-flow/entries/CharityVettingManualContactDetailsEntry';
import CharityVettingReviewDetailsEntry from '../../../common-flow/entries/CharityVettingReviewDetailsEntry';
import CharityVettingSearchDetailsEntry from '../../../common-flow/entries/CharityVettingSearchDetailsEntry';
import CharityVettingSocialAccountsEntry from '../../../common-flow/entries/CharityVettingSocialAccountsEntry';
import CharityVettingUnwantedFoodEntry from '../../../common-flow/entries/CharityVettingUnwantedFoodEntry';
import { vettingPath } from '../../../common-flow/entries/path';
import { FR_DECLARATIONS } from '../components/steps/declaration-step/frDeclarations';
import { FR_DOCUMENTS } from '../frDocuments';

import AgrementDateRoute from './AgrementDateRoute';
import ArretePublicationDateRoute from './ArretePublicationDateRoute';
import AuthorisedFoodAidRoute from './AuthorisedFoodAidRoute';
import CharityFoodSafetyQThreeRoute from './CharityFoodSafetyQThreeRoute';
import CharitySirenRnaRoute from './CharitySirenRnaRoute';
import DeclarationStepRoute from './DeclarationStepRoute';
import DecreePublicationDatesRoute from './DecreePublicationDatesRoute';
import DocumentUploadRoute from './DocumentUploadRoute';
import OrganisationOtherOptionRoute from './OrganisationOtherOptionRoute';
import OrganisationPurposeRoute from './OrganisationPurposeRoute';
import OrganisationSituationRoute from './OrganisationSituationRoute';
import OrganisationSpecificTypeRoute from './OrganisationSpecificTypeRoute';

const CharityVettingRoutesFR = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={vettingPath.getStartedPath} element={<CharityVettingGetStartedEntry />} />
        <Route path={vettingPath.searchPath} element={<CharityVettingSearchDetailsEntry />} />
        <Route
          path={vettingPath.contactDetailsPath}
          element={<CharityVettingContactDetailsEntry />}
        />
        <Route
          path={vettingPath.manualContactDetailsPath}
          element={<CharityVettingManualContactDetailsEntry />}
        />
        <Route
          path={vettingPath.legalRepresentativePath}
          element={<CharityVettingLegalRepresentativeEntry />}
        />
        <Route path={vettingPath.authorisedFoodAidPath} element={<AuthorisedFoodAidRoute />} />
        <Route path={vettingPath.organisationPurposePath} element={<OrganisationPurposeRoute />} />
        <Route
          path={vettingPath.organisationSpecificTypePath}
          element={<OrganisationSpecificTypeRoute />}
        />
        <Route
          path={vettingPath.decreePublicationDatesPath}
          element={<DecreePublicationDatesRoute />}
        />
        <Route
          path={vettingPath.arretePublicationDatePath}
          element={<ArretePublicationDateRoute />}
        />
        <Route
          path={vettingPath.organisationSituationPath}
          element={<OrganisationSituationRoute />}
        />
        <Route
          path={vettingPath.organisationOtherOptionPath}
          element={<OrganisationOtherOptionRoute />}
        />
        <Route path={vettingPath.agrementDatePath} element={<AgrementDateRoute />} />
        <Route path={vettingPath.sirenPath} element={<CharitySirenRnaRoute />} />
        <Route path={vettingPath.foodSafetyQThreePath} element={<CharityFoodSafetyQThreeRoute />} />

        {FR_DECLARATIONS.map((declaration) => (
          <Route
            key={declaration.segment}
            path={declaration.segment}
            element={<DeclarationStepRoute />}
          />
        ))}

        {FR_DOCUMENTS.map((document) => (
          <Route key={document.segment} path={document.segment} element={<DocumentUploadRoute />} />
        ))}

        <Route
          path={vettingPath.donationPreferencesPath}
          element={<CharityVettingDonationPreferencesEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodsPath}
          element={<CharityVettingAcceptsAllFoodsEntry />}
        />
        <Route
          path={vettingPath.acceptAllNonFoodPath}
          element={<CharityVettingAcceptsAllNonFoodEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodAndNonFoodPath}
          element={<CharityVettingAcceptsAllFoodAndNonFoodEntry />}
        />
        <Route path={vettingPath.unwantedFoodPath} element={<CharityVettingUnwantedFoodEntry />} />
        <Route
          path={vettingPath.socialAccountsPath}
          element={<CharityVettingSocialAccountsEntry />}
        />
        <Route
          path={vettingPath.reviewDetailsPath}
          element={<CharityVettingReviewDetailsEntry />}
        />
      </Routes>
    </Suspense>
  );
};

export default CharityVettingRoutesFR;
